import React from 'react';
import { IContactPointSortedStructure, IContactPointViewItem } from '../../../interfaces';
import styles from './contactPointSearcher.module.scss';
import parse from 'react-html-parser';

interface IContactPointsAlphabaticSorted {
    ContactPoints: IContactPointViewItem[];
    onClick: (view: IContactPointViewItem, event: React.SyntheticEvent) => void;
    searchValue?: string;
}

const RecipientList: React.FC<IContactPointsAlphabaticSorted> = ({ ContactPoints, onClick, searchValue }) => {
    const groupedContacts = ContactPoints.reduce((acc, recipient) => {
        let firstLetter = recipient.name[0].toUpperCase();
        if (firstLetter === 'A' && recipient.name[1].toUpperCase() === 'A') {
            firstLetter = 'AA';
        }
        if (!acc[firstLetter]) {
            acc[firstLetter] = [];
        }
        acc[firstLetter].push(recipient);
        return acc;
    }, {} as { [key: string]: IContactPointViewItem[] });

    const splitObject = (
        obj: IContactPointSortedStructure
    ): { firstPart: IContactPointSortedStructure; secondPart: IContactPointSortedStructure } => {
        const keys: string[] = Object.keys(obj);
        const halfIndex = Math.ceil(keys.length / 2);

        const firstPart: IContactPointSortedStructure = {};
        const secondPart: IContactPointSortedStructure = {};

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (i < halfIndex) {
                firstPart[key] = obj[key];
            } else {
                secondPart[key] = obj[key];
            }
        }

        return { firstPart, secondPart };
    };

    const { firstPart, secondPart } = splitObject(groupedContacts);

    const highLightText = (name: string): string => {
        const regex = new RegExp(searchValue, 'gi');
        return name.replace(regex, (match) => `<span class="bold">${match}</span>`);
    };

    const getContactList = (list: IContactPointSortedStructure): JSX.Element => {
        const totalLength = Object.keys(list).reduce((acc) => acc + 1, 0);
        return (
            <div className={styles.columnWrapper}>
                {Object.entries(list).map(([letter, group], index) => (
                    <div className={styles.contactWraper} key={index}>
                        {totalLength > 1 && <div className={styles.alphabetHeader}>{letter}</div>}
                        <div className={styles.listWrapper}>
                            {group.map((recipient, index) => (
                                <div
                                    className={styles.contactList}
                                    key={recipient.id || `${letter}-${index}`}
                                    onClick={(event): void => onClick(recipient, event)}
                                >
                                    {searchValue === '' ? recipient.name : parse(highLightText(recipient.name))}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className={styles.recipientList}>
            {getContactList(firstPart)}
            {getContactList(secondPart)}
        </div>
    );
};

export default RecipientList;
